import "regenerator-runtime/runtime";

import "@fig/libs/client/styles/css";
import "@mantine/core/styles.css";

import {shades} from "@fig/libs/client/styles/js/colors";
import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {setConfig as setFigApiConfig} from "@fig/libs/client/api/fig";
import {PostHogProvider} from "posthog-js/react";
import React, {PropsWithChildren, useEffect} from "react";

const posthogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const isLocalHostname = (hostname?: string | null) =>
  !hostname || ["localhost", "127.0.0.1", "0.0.0.0"].includes(hostname);

const getApiOrigin = () => {
  const hostname = process.env.API_HOSTNAME || "localhost";
  const useHttp = process.env.HTTPS_ENABLED !== "true" && isLocalHostname(hostname);
  const port = useHttp ? process.env.API_PORT_HTTP : process.env.API_PORT_HTTPS;

  return `${useHttp ? "http" : "https"}://${hostname}${port ? `:${port}` : ""}`;
};

const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

const isMobileDevice = () => {
  return (
    /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(navigator.userAgent) ||
    window.matchMedia("(max-width: 767px)").matches
  );
};

setFigApiConfig(getApiOrigin());

export function AppProviders({children}: PropsWithChildren<{}>) {
  useEffect(() => {
    setVh();

    if (isMobileDevice()) {
      console.log("Mobile device detected");
      return;
    }

    console.log("Desktop device detected");
    window.addEventListener("resize", setVh);

    return () => {
      window.removeEventListener("resize", setVh);
    };
  }, []);

  return (
    <MantineProvider
      theme={{
        fontFamily: '"DM Sans", GTWalsheimPro, sans-serif',
        headings: {
          fontFamily: '"Open Sans", PPRadioGrotesk, sans-serif',
        },
        spacing: {xs: "1rem", sm: "1.2rem", md: "1.8rem", lg: "2.2rem", xl: "2.8rem"},
        colors: {
          purple: shades.purple,
          pink: shades.pink,
          blue: shades.blue,
          blue_green: shades.blue_green,
          green: shades.green,
          yellow: shades.yellow,
          orange: shades.orange,
          gray: shades.gray,
          white: [
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
          ],
          text: [
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
            "#0b0b0b",
          ],
        },
      }}>
      <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
        <Notifications />
        {children}
      </PostHogProvider>
    </MantineProvider>
  );
}
